import { useDispatch } from "react-redux";

import { AxiosError } from "axios";

import { setError } from "@redux/slices/errorSlice";

const useMutateError = () => {
  const dispatch = useDispatch();
  return (error: Error | AxiosError, source?: string) => {
    // Todo: use a better hook for dealing specifically with mutation errors.
    // Display more meaningful errors
    if (!error) return;
    dispatch(
      setError({
        error: error.message,
        source: source,
      })
    );
    console.error(error);
  };
};

export default useMutateError;
